import { useEffect, useId, useState } from 'react'
import { Mtds, CheckIcon, DateInputWidget, ModalDialog } from 'prove-common'
import { SaveError } from '../save-error/SaveError'

type AddDuedateModalProps = {
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
  onAddDuedate: (date: string) => void | Promise<void>
}

export const AddDuedateModal = ({
  isOpen,
  setOpen,
  onAddDuedate
}: AddDuedateModalProps) => {
  const dialogId = useId()
  const [duedate, setDuedate] = useState('')
  const [error, setError] = useState(false)
  const [saveError, setSaveError] = useState<unknown>(null)
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    if (isOpen) return

    setDuedate('')
    setError(false)
    setSaveError(null)
  }, [isOpen])

  return (
    <ModalDialog id={dialogId} open={isOpen} onClose={() => setOpen(false)}>
      <Mtds.Button command='close' commandfor={dialogId} aria-label='Lukk' />
      <Mtds.Prose>
        <Mtds.Heading>Legg til innsendingsfrist</Mtds.Heading>
        <SaveError error={saveError} action='legge til fristen' />
        <Mtds.Field label='Dato'>
          <DateInputWidget
            id='duedate'
            value={duedate}
            onChange={setDuedate}
            disabled={isSaving}
          />
          {error && !duedate && (
            <Mtds.Validation>Du må velge en dato</Mtds.Validation>
          )}
        </Mtds.Field>
        <Mtds.Button
          disabled={isSaving}
          aria-busy={isSaving}
          onClick={async () => {
            if (isSaving) return
            if (!duedate) {
              setError(true)
              return
            }
            setIsSaving(true)
            setSaveError(null)
            try {
              await onAddDuedate(duedate)
              setOpen(false)
            } catch (error) {
              setSaveError(error)
            } finally {
              setIsSaving(false)
            }
          }}
          data-variant='primary'
        >
          Opprett
          <CheckIcon />
        </Mtds.Button>
      </Mtds.Prose>
    </ModalDialog>
  )
}
